import { PanelCategory, PanelConfig } from '@helios/panel-base'
import { RawTradeSummaryPanelComponent } from './lib/raw-trade-summary-panel.component'
import { RawTradeSummaryKey } from './panel-key'

export * from './lib/raw-trade-summary.module'
export * from './panel-key'

export const RawTradeSummaryPanelConfig: PanelConfig = {
  key: RawTradeSummaryKey,
  title: 'Raw Trade Summary',
  description: 'View Summary of Raw Trade Processing',
  category: PanelCategory.SUPPLEMENTARY,
  panelComponent: RawTradeSummaryPanelComponent,
  accessPermission: 'accessRawTradeSummaryPanel',
  isExternal: true,
}
